/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EasyClaimDocumentType = {
	Image: 'Image',
	DashboardPicture: 'DashboardPicture',
	DetailPicture: 'DetailPicture',
	DiagonalPicture: 'DiagonalPicture',
	Assessment: 'Assessment',
	AssessmentReport: 'AssessmentReport',
	CalculationReport: 'CalculationReport',
	ReplacementValueReport: 'ReplacementValueReport',
	Invoice: 'Invoice',
	RegistrationDocument: 'RegistrationDocument',
	TrailerPicture: 'TrailerPicture',
	RepairOrder: 'RepairOrder',
	UserReport: 'UserReport',
	Unknown: 'Unknown',
	SpeedCheckReport: 'SpeedCheckReport',
	PoliceReportPicture: 'PoliceReportPicture',
	AccidentLocationPicture: 'AccidentLocationPicture',
	PerpetratorStatement: 'PerpetratorStatement',
	VinPicture: 'VinPicture',
	Additional: 'Additional',
	RegistrationDocumentInside: 'RegistrationDocumentInside',
	FrontLeftPicture: 'FrontLeftPicture',
	RearRightPicture: 'RearRightPicture',
	FrontPerspectivePicture: 'FrontPerspectivePicture',
	RearPerspectivePicture: 'RearPerspectivePicture',
	RightPerspectivePicture: 'RightPerspectivePicture',
	LeftPerspectivePicture: 'LeftPerspectivePicture',
	FrontRightPicture: 'FrontRightPicture',
	RearLeftPicture: 'RearLeftPicture',
	OverallDashboardPicture: 'OverallDashboardPicture',
	WindshieldPicture: 'WindshieldPicture',
	DniInside: 'DniInside',
	DniOutside: 'DniOutside',
	DriverLicenseInside: 'DriverLicenseInside',
	DriverLicenseOutside: 'DriverLicenseOutside',
	VehicleDatasheetInside: 'VehicleDatasheetInside',
	VehicleDatasheetOutside: 'VehicleDatasheetOutside',
	ITV: 'ITV',
	BankAccountStatement: 'BankAccountStatement',
} as const;
export type EasyClaimDocumentType =
	(typeof EasyClaimDocumentType)[keyof typeof EasyClaimDocumentType];

export function instanceOfEasyClaimDocumentType(value: any): boolean {
	for (const key in EasyClaimDocumentType) {
		if (Object.prototype.hasOwnProperty.call(EasyClaimDocumentType, key)) {
			if (EasyClaimDocumentType[key as keyof typeof EasyClaimDocumentType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EasyClaimDocumentTypeFromJSON(json: any): EasyClaimDocumentType {
	return EasyClaimDocumentTypeFromJSONTyped(json, false);
}

export function EasyClaimDocumentTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimDocumentType {
	return json as EasyClaimDocumentType;
}

export function EasyClaimDocumentTypeToJSON(value?: EasyClaimDocumentType | null): any {
	return value as any;
}

export function EasyClaimDocumentTypeToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): EasyClaimDocumentType {
	return value as EasyClaimDocumentType;
}
